import {NaturalReferencingDeviceData, NaturalReferencingPageSpeedDataResponse} from '../../../@types'


const DEFAULT_LIGHTHOUSE_CATEGORY = {
    id: '',
    title: '',
    score: 0,
    description: '',
    manualDescription: '',
    auditRefs: [],
}

const DEFAULT_LIGHTHOUSE_RESULT = {
    categories: {
        performance: {...DEFAULT_LIGHTHOUSE_CATEGORY},
        accessibility: {...DEFAULT_LIGHTHOUSE_CATEGORY},
        'best-practices': {...DEFAULT_LIGHTHOUSE_CATEGORY},
        seo: {...DEFAULT_LIGHTHOUSE_CATEGORY},
    },
}

const transformDevice = (deviceData: NaturalReferencingDeviceData): NaturalReferencingDeviceData => ({
    lighthouseResult: deviceData.error || !deviceData.lighthouseResult || Object.keys(deviceData.lighthouseResult.categories).length === 0 ? DEFAULT_LIGHTHOUSE_RESULT : deviceData.lighthouseResult,
    hasError: !!deviceData.error,
    error: deviceData.error,
    message: deviceData.message,
});

export const TransformPageSpeedResponse = (response: NaturalReferencingPageSpeedDataResponse) => ({
    mobile: transformDevice(response.mobile),
    desktop: transformDevice(response.desktop),
    date: response.date || ''
})